/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { PageSlugProps } from "@cosmos/next-common";
import { Metadata } from "next";
import { notFound } from "next/navigation";

import { GetAppMetadata } from "../common";
import { cosmosPageBlogDetailMetadata } from "../cosmos-blog-detail";
import { cosmosPageEulaKeyMetadata } from "../cosmos-eula-key";
import { cosmosPageHeroAndSectionMetadata } from "../cosmos-hero-and-sections";
import { cosmosPageLegalContentMetadata } from "../cosmos-legal-content";
import { cosmosRedirectPage } from "../cosmos-redirect/CosmosRedirectPage.page";
import { cosmosPageResearchMetadata } from "../cosmos-research/CosmosPageResearch.data";
import { cosmosPageSearchMetadata } from "../cosmos-search";

import { checkValidParams, getKey } from "./selector";

export const metadataSelector = async (
	props: PageSlugProps,
	hygraphLocales: string[],
	getAppMetadata: GetAppMetadata,
	hygraphOwnerId?: string,
	hygraphEndpoint?: string,
): Promise<Metadata> => {
	const valid = checkValidParams(props);
	if (!valid) {
		return notFound();
	}

	const key = await getKey(props, hygraphLocales, hygraphOwnerId, hygraphEndpoint);

	if (!key) {
		return notFound();
	}

	//set root slug to empty string
	const slug = "";
	const siteProps = { hygraphEndpoint, hygraphOwnerId };

	switch (key) {
		case "cosmosPageBlogDetail": {
			return cosmosPageBlogDetailMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
		}
		case "cosmosPageEulaKey": {
			return cosmosPageEulaKeyMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
		}
		case "cosmosPageLegalContent": {
			return cosmosPageLegalContentMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
		}
		case "cosmosPageRedirect": {
			return cosmosRedirectPage(props, hygraphOwnerId, hygraphEndpoint);
		}
		case "cosmosPageSearch": {
			return cosmosPageSearchMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
		}
		case "cosmosPageResearch": {
			return cosmosPageResearchMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
		}
		default:
			return cosmosPageHeroAndSectionMetadata({ ...props, slug, hygraphLocales, getAppMetadata, ...siteProps });
	}
};
